import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'new-field',
  templateUrl: './new-field.component.html'
})
export class NewFieldComponent {
  @Input() fields;
  @Input() labelField: boolean = false;
  @Input() scope;
  @Input() hide;
  field: any = {};

  constructor(
    private modalService: NgbModal
  ) { }

  open(content) {
    this.field = {
      hidden: parseInt(this.hide) || 0,
      ord: 0,
      options: '',
      value: '',
      label: '',
      sub_label: '',
      placeholder: '',
      engine_id: '',
      required: 0,
      limit: 0
    };
    this.modalService.open(content).result.then(result => {
      result.scope = this.scope;
      this.fields.push(result);
    }).catch(reason => {});
  }
}



// WEBPACK FOOTER //
// ./src/app/components/new-field/new-field.component.ts